/*eslint-disable*/ export const messages = {
    "Go to the first page": "Aller à la première page",
    "Go to the last page": "Aller à la dernière page",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Pagination, affichage des entités ",
        ["from"],
        " à ",
        ["to"],
        " sur ",
        ["total"],
    ],
    "Show next {entitiesPerPage} entities": ["Afficher les ", ["entitiesPerPage"], " entités suivantes"],
    "Show previous {entitiesPerPage} entities": ["Afficher les ", ["entitiesPerPage"], " entités précédentes"],
    "{from} through {to} of {total}": [["from"], " à ", ["to"], " sur ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " sur ", ["total"]],
};
